import { createIndexSizeError } from '../factories/index-size-error';
export var wrapAudioBufferCopyChannelMethods = function wrapAudioBufferCopyChannelMethods(audioBuffer) {
  audioBuffer.copyFromChannel = function (destination, channelNumber) {
    var startInChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (channelNumber >= audioBuffer.numberOfChannels || startInChannel >= audioBuffer.length) {
      throw createIndexSizeError();
    }

    var channelData = audioBuffer.getChannelData(channelNumber);
    var channelLength = channelData.length;
    var destinationLength = destination.length;

    for (var i = 0; i + startInChannel < channelLength && i < destinationLength; i += 1) {
      destination[i] = channelData[i + startInChannel];
    }
  };

  audioBuffer.copyToChannel = function (source, channelNumber) {
    var startInChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (channelNumber >= audioBuffer.numberOfChannels || startInChannel >= audioBuffer.length) {
      throw createIndexSizeError();
    }

    var channelData = audioBuffer.getChannelData(channelNumber);
    var channelLength = channelData.length;
    var sourceLength = source.length;

    for (var i = 0; i + startInChannel < channelLength && i < sourceLength; i += 1) {
      channelData[i + startInChannel] = source[i];
    }
  };
};